import { render, staticRenderFns } from "./distributoriAssociati.vue?vue&type=template&id=4e0500cd&"
import script from "./distributoriAssociati.vue.ts?vue&type=script&lang=ts&"
export * from "./distributoriAssociati.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports